import DSDialog from "views/system-design/DSDialog";
import { Ticket } from "../../types";
import { useIsMobile } from "../../hooks/useIsMobile";
import TicketDetailContent from "./TicketDetailContent";

interface TicketDetailModalProps {
  ticket: Ticket;
  onClose: () => void;
}

export default function TicketDetailModal({
  ticket,
  onClose,
}: TicketDetailModalProps) {
  const isMobile = useIsMobile();

  return (
    <DSDialog
      open
      onClose={onClose}
      fullWidth
      fullScreen={isMobile}
      maxWidth={isMobile ? undefined : "md"}
    >
      <TicketDetailContent ticket={ticket} onClose={onClose} layout="modal" />
    </DSDialog>
  );
}
